/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  TransferAvailableBalancesOptions,
  TransferAvailableBalancesStatus201,
  TransferAvailableBalancesStatus400,
  TransferAvailableBalancesStatus401,
  TransferAvailableBalancesStatus403,
  TransferAvailableBalancesStatus409,
  TransferAvailableBalancesStatus500,
} from '../types/TransferAvailableBalances'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { transferAvailableBalances } from '../clients/transferAvailableBalances'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const transferAvailableBalancesMutationKey = () =>
  [{ url: '/v1/positions/transfer_balances' }] as const

export function transferAvailableBalancesMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = transferAvailableBalancesMutationKey()
  return mutationOptions<
    TransferAvailableBalancesStatus201,
    ResponseErrorConfig<
      | TransferAvailableBalancesStatus400
      | TransferAvailableBalancesStatus401
      | TransferAvailableBalancesStatus403
      | TransferAvailableBalancesStatus409
      | TransferAvailableBalancesStatus500
    >,
    TransferAvailableBalancesOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return transferAvailableBalances({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Transfer available balance between a user's accounts (e.g. global to isolated position)
 * {@link /v1/positions/transfer_balances}
 */
export function useTransferAvailableBalances<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TransferAvailableBalancesStatus201,
      ResponseErrorConfig<
        | TransferAvailableBalancesStatus400
        | TransferAvailableBalancesStatus401
        | TransferAvailableBalancesStatus403
        | TransferAvailableBalancesStatus409
        | TransferAvailableBalancesStatus500
      >,
      TransferAvailableBalancesOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? transferAvailableBalancesMutationKey()

  const baseOptions = transferAvailableBalancesMutationOptions(config) as UseMutationOptions<
    TransferAvailableBalancesStatus201,
    ResponseErrorConfig<
      | TransferAvailableBalancesStatus400
      | TransferAvailableBalancesStatus401
      | TransferAvailableBalancesStatus403
      | TransferAvailableBalancesStatus409
      | TransferAvailableBalancesStatus500
    >,
    TransferAvailableBalancesOptions,
    TContext
  >

  return useMutation<
    TransferAvailableBalancesStatus201,
    ResponseErrorConfig<
      | TransferAvailableBalancesStatus400
      | TransferAvailableBalancesStatus401
      | TransferAvailableBalancesStatus403
      | TransferAvailableBalancesStatus409
      | TransferAvailableBalancesStatus500
    >,
    TransferAvailableBalancesOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    TransferAvailableBalancesStatus201,
    ResponseErrorConfig<
      | TransferAvailableBalancesStatus400
      | TransferAvailableBalancesStatus401
      | TransferAvailableBalancesStatus403
      | TransferAvailableBalancesStatus409
      | TransferAvailableBalancesStatus500
    >,
    TransferAvailableBalancesOptions,
    TContext
  >
}
